// Global Instructions Rule Applied!

export const SET_CAPITAL_CALLS = 'capital_calls/SET_CAPITAL_CALLS' as const
export const APPEND_CAPITAL_CALLS = 'capital_calls/APPEND_CAPITAL_CALLS' as const
export const SET_ACTIVE_FILTERS = 'capital_calls/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'capital_calls/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'capital_calls/CLEAR_ACTIVE_FILTERS' as const
export const UPDATE_CAPITAL_CALL_RECORD = 'capital_calls/UPDATE_CAPITAL_CALL_RECORD' as const
export const REMOVE_CAPITAL_CALL = 'capital_calls/REMOVE_CAPITAL_CALL' as const
